import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import dataV from '@jiaminghi/data-view'

import './assets/common.less'

Vue.config.productionTip = false

// 注册 DataV 数据大屏组件库（dv-full-screen-container / dv-border-box / dv-charts 等）
Vue.use(dataV)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
